// ** Initial State
const initialState = {
  selectedAdminUser: {},
  adminUserList: [],
  duplCnt: null,
  total: 1,
  params: {}
}

const manager = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ADMIN_LIST':
      return { ...state,
        adminUserList: action.data.adminUserList
      }
    case 'CHECK_LOGIN_ID':
      return { ...state,
        duplCnt : action.data
      }
    case 'INSERT_ADMIN':
      return {
        ...state,
        data: action.data
        // total: action.totalPages,
        // params: action.params
      }
    case 'SELECT_ADMIN_USER':
      return {
        ...state,
        selectedAdminUser: action.data
      }
    default:
      return { ...state }
  }
}
export default manager
